import * as ReactRouterDom from 'react-router-dom';
import Navbar from './components/navigation/Navbar';
import usePageTracking from './hooks/usePageTracking';
import AboutPage from './pages/AboutPage';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';

function AppContent() {
  usePageTracking();

  return (
    <>
      <Navbar />
      <ReactRouterDom.Routes>
        <ReactRouterDom.Route path="/" element={<HomePage />} />
        <ReactRouterDom.Route path="/about" element={<AboutPage />} />
        <ReactRouterDom.Route path="/services" element={<ServicesPage />} />
        <ReactRouterDom.Route path="*" element={<ReactRouterDom.Navigate to="/" replace />} />
      </ReactRouterDom.Routes>
    </>
  );
}

function App() {
  return <AppContent />;
}

export default App;
